import {TemplateService} from '../../libs/ui/src/index';
import {client} from '../apiService';
const _TemplateService = new TemplateService({client});
export {_TemplateService as TemplateService};
